import { Guid } from '@web/utils';
import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { WarehouseReleaseContextOperationsResponse } from './warehouse-release-context-operations.response';
import { WarehouseReleaseStatus } from '../../enums/warehouse-release-status';

@jsonObject
export class WarehouseReleaseCollectionItemResponse {
  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(Date)
  public readonly releasedAt!: Date;

  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly number!: string;

  @jsonMember(String)
  public readonly status!: WarehouseReleaseStatus;

  @jsonArrayMember(String, { name: 'goodsNames' })
  public readonly productNames!: string[];

  @jsonMember(WarehouseReleaseContextOperationsResponse)
  public readonly contextOperations!: WarehouseReleaseContextOperationsResponse;
}
